import { Component, inject, input } from '@angular/core';

import Social from '../../../../entity/Social';
import User from '../../../../entity/User';
import { ActionMenuService } from '../services/action-menu.service';
import { HostService } from '../services/host-service';
import { SideSectionService } from '../services/side-section.service';
import { SideContainerType } from '../social-menu/enums/SideContainerType';

@Component({
  selector: 'app-right-collapsible-section',
  templateUrl: './right-collapsible-section.component.html',
  styleUrls: ['./right-collapsible-section.component.scss'],
  standalone: false,
})
export class RightCollapsibleSectionComponent {
  protected sideSectionService = inject(SideSectionService);
  private actionMenuService = inject(ActionMenuService);
  private hostService = inject(HostService);

  public readonly isHost = input<boolean>();
  public readonly user = input<User>();
  public readonly social = input<Social>();
  public readonly showButton = input<boolean>();

  public toggleMenu(): void {
    this.actionMenuService.toggleMenu();
    this.hostService.requestOpenGuestList$.next(false);
  }

  public get sideContainerType(): typeof SideContainerType {
    return SideContainerType;
  }
}
